import React from 'react';
import { DomainServices } from '../../components/services/DomainServices';

export const DomainServicesPage: React.FC = () => {
  return <DomainServices />;
};